import { render, staticRenderFns } from "./ThreecolumnRow.vue?vue&type=template&id=6c90f7aa&scoped=true&"
import script from "./ThreecolumnRow.vue?vue&type=script&lang=js&"
export * from "./ThreecolumnRow.vue?vue&type=script&lang=js&"
import style0 from "./ThreecolumnRow.vue?vue&type=style&index=0&id=6c90f7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90f7aa",
  null
  
)

export default component.exports